import React, { useEffect } from 'react';


const PayPalDonateButton = () => {
  useEffect(() => {
    if (window.PayPal && window.PayPal.Donation) {
      window.PayPal.Donation.Button({
        env: 'production',
        hosted_button_id: process.env.REACT_APP_PAYPAL_HOSTED_BUTTON_ID,
        image: {
          src: 'https://www.paypalobjects.com/en_US/i/btn/btn_donateCC_LG.gif',
          title: 'PayPal - The safer, easier way to pay online!',
          alt: 'Donate with PayPal button',
        },
        onComplete: (params) => {
          console.log('Donation completed:', params);
        },
      }).render('#paypal-donate-button-container');
    }
  }, []);

  return (
    <div 
      id="paypal-donate-button-container" 
      className="flex items-center justify-center gap-2 w-full px-6 py-3 bg-[#0070BA] text-white rounded-lg hover:bg-[#005C9E] transition-colors cursor-pointer"
    />
  );
};

export default PayPalDonateButton;